import styled from 'styled-components';
import { colorPrimary, colorWhite } from '@tds/core-colours';

export const ButtonWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const ExportButton = styled.button`
  color: ${colorWhite};
  background-color: ${colorPrimary};
`;
